<template>
  <section class="av-crit" aria-labelledby="avaluos-criteria-title">
    <h2 id="avaluos-criteria-title" class="av-crit__title">Criterios si lo realizas con una institución bancaria</h2>

    <div class="av-crit__body">
      <p class="wd-body">
        Tienes la posibilidad de realizar tu avalúo con cualquier institución bancaria, siempre y cuando cumpla con <br class="br-d">los siguientes criterios:
      </p>

      <ul class="av-crit__list">
        <li v-for="criterion in criteria" :key="criterion" class="av-crit__item">
          <img :src="checkIcon" alt="" aria-hidden="true">
          <span class="wd-body">{{ criterion }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import checkIcon from '../../../assets/avaluos-figma/check.svg'

const criteria = [
  'Expedido por un banco en hoja membretada y con sello de la institución.',
  'Que el propósito del documento sea para Originación de crédito.',
  'Otras instituciones que son aceptados: TINSA, Tasvaluo, Corporación Mexicana y BIM'
]
</script>

<style scoped>
.av-crit { display: flex; flex-direction: column; gap: var(--ds-space-5); }

.av-crit__title {
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: 32px;
  font-weight: 700;
  line-height: normal;
}

.av-crit__body { display: flex; flex-direction: column; gap: var(--ds-space-4); }
.av-crit__list { display: flex; flex-direction: column; gap: var(--ds-space-5); margin: 0; padding: 0; list-style: none; }
.av-crit__item { display: flex; align-items: center; gap: var(--ds-space-3); }
.av-crit__item img { flex: 0 0 24px; width: 24px; height: 24px; object-fit: contain; }
</style>
